module.exports = __webpack_public_path__ + "static/media/IconoReferenciasBibliograficas.cb81d562.svg";